import { useAppState } from "AppState";
import Button from "components/common/Button/Button";
import Container from "components/common/Grid/Container";
import PanelLayout from "components/common/PanelLayout/PanelLayout";
import Title from "components/common/Title";
import Widget from "components/common/Widget";
import { LocationState } from "history";
import * as React from "react";
import { Col, Row } from "react-grid-system";
import { Link } from "react-router-dom";
import { Routes } from "router";
import strings from "static/strings.js";

interface IProps {
  history: { goBack: () => void };
  location: LocationState;
  state: object;
}

// TODO: This should be a back button that persist the cart state
const WaitForBudtender = ({ history, location }: IProps) => {
  const { locationName } = useAppState();
  return (
    <PanelLayout
      title={locationName}
      titleSecondary="Complete Rewards"
      backButtonHandler={history.goBack}
    >
      <Container>
        <Row justify="center">
          <Col sm={11}>
            <Widget text white>
              <Title noMargin>
                Please give the tablet to the {strings.cashier} to get your
                rewards!
              </Title>
              <Link
                to={{
                  pathname: Routes.RedeemConfirmation,
                  state: location.state
                }}
              >
                <Button primary wide tertiary>
                  Next
                </Button>
              </Link>
            </Widget>
          </Col>
        </Row>
      </Container>
    </PanelLayout>
  );
};

export default WaitForBudtender;



// WEBPACK FOOTER //
// ./src/screens/RedeemRewards/WaitForBudtender/WaitForBudtender.tsx